import PropTypes from 'prop-types';
import React from 'react';

import BrToggle from '@components/BrToggle';

export default function ToggleColumn({ row, col, cell }) {
  const { onText, offText, onColor, offColor, onClick } = col.columnConfig;
  return (
    <BrToggle
      className="br-table-toggle-column"
      onText={onText}
      offText={offText}
      onColor={onColor}
      offColor={offColor}
      onClick={(value) => onClick(row, value)}
      isOn={!!cell.value}
      isDisabled={cell.isColumnDisabled || cell.isDisabled}
      tooltipText={cell.tooltipText}
    />
  );
}

ToggleColumn.propTypes = {
  row: PropTypes.object.isRequired, // row data
  col: PropTypes.shape({
    // column config
    columnConfig: PropTypes.shape({
      onText: PropTypes.string,
      offText: PropTypes.string,
      onColor: PropTypes.string,
      offColor: PropTypes.string,
      onClick: PropTypes.func.isRequired, // (row, value) :=> {}
    }).isRequired,
  }).isRequired,
  cell: PropTypes.shape({
    value: PropTypes.any,
    isDisabled: PropTypes.bool,
    tooltipText: PropTypes.string,
  }).isRequired,
};
